import React from 'react'
import {
    Card,
    CardBody,
    CardHeader,
    Col,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Modal,
} from "reactstrap";
import Button from "reactstrap/es/Button";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import InvoicesView from "./InvoicesView";
import EditInvoiceSettingsView from "./EditInvoiceSettingsView";
import lsHelpers from "../../helpers/LsHelper";
import EditInvoiceView from "./EditInvoiceView";
import stringHelpers from "../../helpers/StringHelper";
import HeaderAlert from "../Alerts/SuccessAlert";
import {isMobile} from 'react-device-detect';

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class Invoices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            period: this.setPeriod(),
            showInvoiceEditor: false,
            selectedInvoiceId: null,
            showFilters: false,
            invoiceData: null,
            alertData: null,
            filters: {
                tickets: false,
                incomes: false,
                expenses: false,
                other: false,
                search: "",
            },
            validation: {
                start: true,
                end: true
            },
        };
    }

    onInvoiceSelected = this.onInvoiceSelected.bind(this);
    deleteInvoice = this.deleteInvoice.bind(this);
    editInvoice = this.editInvoice.bind(this);
    sendInvoice = this.sendInvoice.bind(this);
    showFilters = this.showFilters.bind(this);
    handleTypeSelected = this.handleTypeSelected.bind(this);
    handleNetworkError = this.handleNetworkError.bind(this);

    func = this.exportAllInvoices.bind(this)

    componentDidMount() {
        this.resetStoredFilterValues()
        this.getData()

        window.addEventListener('invoice-export-event', this.func);
    }

    componentWillUnmount() {
        window.removeEventListener('invoice-export-event', this.func);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.period !== this.state.period) {
            this.handleValidation();
            this.setState({showSearchButton: true})
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-start":
                this.setState(prevState => ({
                    period: {
                        ...prevState.period,
                        start: newValue
                    }
                }));
                lsHelpers.setReportDateStart(newValue);
                break;
            case "input-end":
                this.setState(prevState => ({
                    period: {
                        ...prevState.period,
                        end: newValue
                    }
                }));
                lsHelpers.setReportDateEnd(newValue);
                break;
            case "input-search":
                lsHelpers.setInvoiceFilters("s", newValue)

                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        search: newValue
                    }
                }));
                lsHelpers.setReportDateEnd(newValue);
                break;
            default:
                return null;
        }
    }

    closeEditInvoiceView() {
        this.setState({showInvoiceEditor: false});
        this.getData();
    }

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.alertData &&
                    <HeaderAlert alertData={this.state.alertData}/>
                    }

                    {this.state.showInvoiceModal &&
                    this.renderInvoiceModal()
                    }

                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    {this.state.showFilters &&
                    this.renderFilterModal()
                    }

                    <Col lg="12">
                        {this.state.showInvoiceEditor === true &&
                        <EditInvoiceView closeEditInvoiceView={this.closeEditInvoiceView.bind(this)}
                                         invoiceId={this.state.selectedInvoiceId}/>
                        }
                        {this.state.showInvoiceEditor !== true &&
                        <Card className="bg-default shadow">


                            <Row style={{marginLeft: 4}}>
                                <Col lg="3">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-start"
                                        >
                                            {commonStrings.from}
                                        </label>
                                        <Input
                                            className={this.state.validation.start === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange.bind(this)}
                                            defaultValue={this.state.period.start}
                                            id="input-start"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="3">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-end"
                                        >
                                            {commonStrings.until}
                                        </label>

                                        <Input
                                            className={this.state.validation.end === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange.bind(this)}
                                            defaultValue={this.state.period.end}
                                            id="input-end"
                                            type="date"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col lg="auto" style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <Row style={{marginTop: 4}}>
                                        {this.state.showSearchButton &&
                                        <Col>
                                            <Button

                                                color={"success"}
                                                onClick={this.getData.bind(this)}
                                                size="lg"
                                            >
                                                {commonStrings.search}
                                            </Button>
                                        </Col>
                                        }
                                        {!this.state.showSearchButton &&
                                        <Col>
                                            <Button
                                                color="white"
                                                outline={true}
                                                onClick={e => this.toggleInvoiceModal(e)}
                                                size="lg"
                                            >
                                                <i className="fas fa-cog text-white mr-2"/>
                                                {resourceStrings.invoices.invoice_settings}
                                            </Button>

                                            <Button
                                                color="white"
                                                outline={true}
                                                onClick={e => this.createInvoice(e)}
                                                size="lg"
                                            >
                                                <i className="fas fa-plus text-white mr-2"/>
                                                {resourceStrings.invoices.create}
                                            </Button>

                                            <Button
                                                color={this.filtersAreEmpty() ? "white" : "danger"}
                                                outline={true}
                                                onClick={e => this.showFilters(e)}
                                                size="lg"
                                            >
                                                <i className={this.filtersAreEmpty() ? "fas fa-filter text-white mr-2" : "fas fa-filter text-danger mr-2"}/>
                                                {reportStrings.filter}
                                            </Button>
                                        </Col>
                                        }
                                    </Row>
                                </Col>

                            </Row>
                            <Card className="bg-default shadow">
                                <CardHeader className="bg-transparent">
                                    <Row>
                                        <h2 className="text-white mb-0">{resourceStrings.cabinet.invoices}</h2>

                                        <div style={{position: "absolute", right: 20, top: 10}}>
                                        </div>
                                    </Row>
                                    <Row>
                                        <h5 className="text-warning mb-0 text-lowercase">{this.reportStats()}</h5>
                                    </Row>
                                </CardHeader>
                                {this.renderReport()}
                            </Card>
                        </Card>
                        }
                    </Col>
                </>
            </LoadingOverlay>
        )
    }

    showFilters(e) {
        e.preventDefault();

        this.setState({showFilters: true})
    }

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    reportStats() {
        return (this.state.invoiceData ? this.state.invoiceData.length : "0") + " " + resourceStrings.cabinet.invoices
    }

    setPeriod() {
        lsHelpers.setReportDateStart(dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()));
        lsHelpers.setReportDateEnd(dateHelpers.databaseDate(dateHelpers.lastDayOfMonth()));
        return {
            start: dateHelpers.databaseDate(dateHelpers.firstDayOfMonth()),
            end: dateHelpers.databaseDate(dateHelpers.lastDayOfMonth())
        };
    }

    exportAllInvoices() {
        if (this.datesAreValid()) {
            this.setState({isLoading: true});

            reportApiService.invoices(this.state.period, this.state.filters, true)
                .then(res => {
                    this.setState({isLoading: false});
                    alert("ok")
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    getData() {
        if (this.datesAreValid()) {
            this.setState({isLoading: true, invoiceData: null, showFilters: false});

            reportApiService.invoices(this.state.period, this.state.filters)
                .then(res => {
                    this.setState({
                        invoiceData: res,
                        isLoading: false,
                        showSearchButton: false
                    });

                    this.renderReport()
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    renderReport() {
        if (this.state.invoiceData !== null) {
            return <InvoicesView
                invoiceData={this.state.invoiceData}
                onInvoiceSelected={this.onInvoiceSelected}
                deleteInvoice={this.deleteInvoice}
                editInvoice={this.editInvoice}
                sendInvoice={this.sendInvoice}
            />;
        }
    }

    deleteInvoice(e, invoice) {
        e.preventDefault();

        reportApiService.deleteInvoice(invoice.id)
            .then(res => {
                this.getData();
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    sendInvoice(e, invoice) {
        this.setState({isLoading: true})
        e.preventDefault();

        reportApiService.sendInvoice(invoice.id)
            .then(res => {
                this.setState({
                    isLoading: false,
                    alertData: {
                        type: 'success',
                        text: `${alertStrings.invoice_sent_success}`
                    },
                })
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    editInvoice(e, invoice) {
        if (e) e.preventDefault();

        this.setState({selectedInvoiceId: invoice.id, showInvoiceEditor: true})
    }

    onInvoiceSelected(invoice) {
        reportApiService.invoiceLink(invoice.id)
            .then(res => {
                if (isMobile) {
                    window.open(`https://app.openmanagerapp.com/invoices/invoice.pdf?sc=${res}`, "_self")
                }
                else{
                    window.open(`https://app.openmanagerapp.com/invoices/invoice.pdf?sc=${res}`, "_blank")
                }
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    handleValidation() {
        this.validateDates();
    }

    validateDates() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: start <= end,
                    end: start <= end,
                }
            }));
        } else {
            this.setState(prevState => ({
                validation: {
                    ...prevState.validation,
                    start: dateHelpers.isValidDate(start),
                    end: dateHelpers.isValidDate(end),
                }
            }));
        }
    }

    datesAreValid() {
        const start = new Date(this.state.period.start);
        const end = new Date(this.state.period.end);

        if (dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)) {
            return start <= end
        } else {
            return dateHelpers.isValidDate(start) && dateHelpers.isValidDate(end)
        }
    }

    toggleInvoiceModal = state => {
        this.setState({
            showInvoiceModal: !this.state.showInvoiceModal
        });
    };

    closeEditInvoiceSettingsView(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({showInvoiceModal: false});
    }

    renderInvoiceModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showInvoiceModal}
                toggle={() => this.toggleInvoiceModal("formModal")}
            >
                <div className="modal-body p-0">
                    <Card className="bg-secondary shadow border-0">
                        <CardHeader className="bg-transparent pb-2">
                            <div className="text-muted text-center mt-2 mb-3">
                                <h4>{resourceStrings.invoices.invoice_settings}</h4>
                                <small>{resourceStrings.invoices.invoice_settings_expl}</small>
                            </div>
                        </CardHeader>
                        <CardBody className="px-lg-5 py-lg-5">
                            <EditInvoiceSettingsView
                                closeEditInvoiceSettingsView={this.closeEditInvoiceSettingsView.bind(this)}
                                handleError={this.handleNetworkError}
                            />
                        </CardBody>
                    </Card>
                </div>
            </Modal>
        )
    }

    toggleFilters() {
        this.setState({showFilters: !this.state.showFilters});
    }

    renderFilterModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showFilters}
                toggle={() => this.toggleFilters("formModal")}
            >
                <div className="modal-header bg-gradient-success">
                    <h6 className="modal-title" id="modal-title-notification">
                        <h4 className="text-white">{reportStrings.filter}</h4>
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleFilters()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="p-0 bg-gradient-success ">

                    <label className="ml-4">
                        {resourceStrings.invoices.invoice_type}
                    </label>

                    <div className="custom-control custom-control-alternative custom-checkbox mx-4 text-white">
                        <input
                            className="custom-control-input"
                            id="filter-tickets"
                            onChange={e => this.handleTypeSelected(e, "t")}
                            checked={this.state.filters.tickets === true}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-tickets">
                            {resourceStrings.tickets}
                        </label>
                    </div>

                    <div className="custom-control custom-control-alternative custom-checkbox mx-4 text-white">
                        <input
                            className="custom-control-input"
                            id="filter-incomes"
                            onChange={e => this.handleTypeSelected(e, "i")}
                            checked={this.state.filters.incomes === true}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-incomes">
                            {stringHelpers.capitalize(resourceStrings.incomes)}
                        </label>
                    </div>

                    <div className="custom-control custom-control-alternative custom-checkbox mx-4 text-white">
                        <input
                            className="custom-control-input"
                            id="filter-expenses"
                            onChange={e => this.handleTypeSelected(e, "e")}
                            checked={this.state.filters.expenses === true}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-expenses">
                            {stringHelpers.capitalize(resourceStrings.cabinet.expenses)}
                        </label>
                    </div>

                    <div className="custom-control custom-control-alternative custom-checkbox mx-4 text-white mb-4">
                        <input
                            className="custom-control-input"
                            id="filter-other"
                            onChange={e => this.handleTypeSelected(e, "o")}
                            checked={this.state.filters.other === true}
                            type="checkbox"
                        />
                        <label className="custom-control-label" htmlFor="filter-other">
                            {resourceStrings.categories.other}
                        </label>
                    </div>

                    <label className="ml-4">
                        {resourceStrings.invoices.search_by_name}
                    </label>

                    <div className="mx-4 mb-4">
                        <FormGroup className="mb-0">
                            <InputGroup className="input-group-alternative">
                                <InputGroupAddon addonType="prepend">
                                    <InputGroupText>
                                        <i className="fas fa-search"/>
                                    </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                    value={this.state.filters.search}
                                    id="input-search"
                                    onChange={this.handleChange.bind(this)}
                                    placeholder={commonStrings.search} type="text"/>
                            </InputGroup>
                        </FormGroup>
                    </div>

                    <div className="mx-4 mb-4">
                        <Button
                            color={"warning"}
                            onClick={this.getData.bind(this)}
                            size="lg"
                        >
                            {commonStrings.search}
                        </Button>
                    </div>
                </div>
            </Modal>
        )
    }

    handleTypeSelected(event, type) {
        const checked = event.target.checked;
        lsHelpers.setInvoiceFilters(type, checked)

        switch (type) {
            case "t":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        tickets: checked
                    }
                }));
                break;
            case "i":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        incomes: checked
                    }
                }));
                break;
            case "e":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        expenses: checked
                    }
                }));
                break;
            case "o":
                this.setState(prevState => ({
                    filters: {
                        ...prevState.filters,
                        other: checked
                    }
                }));
                break;
            default:
                break;
        }
    }

    filtersAreEmpty() {
        return Object.values(this.state.filters).every(item => !item)
    }

    createInvoice(e) {
        e.preventDefault();
        this.setState({showInvoiceEditor: true})
    }

    resetStoredFilterValues() {
        lsHelpers.setInvoiceFilters("t", false)
        lsHelpers.setInvoiceFilters("i", false)
        lsHelpers.setInvoiceFilters("o", false)
        lsHelpers.setInvoiceFilters("e", false)
        lsHelpers.setInvoiceFilters("s", null)
    }
}

Invoices.propTypes = propTypes;